
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("aNyyT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "closeDialog", () => $6b540b9522e1fdaf$export$34bf1befb2fab61a);
$parcel$export(module.exports, "getOpenDialog", () => $6b540b9522e1fdaf$export$cf40ddca756b7741);
$parcel$export(module.exports, "useModalDialogCleanupEffect", () => $6b540b9522e1fdaf$export$586cda8757903229);
$parcel$export(module.exports, "useRegisterModalDialogAnalytics", () => $6b540b9522e1fdaf$export$fc10f874e8bd1adc);
$parcel$export(module.exports, "useInlineDialogZIndexOverrideLayoutEffect", () => $6b540b9522e1fdaf$export$84648db9790b0ee);
$parcel$export(module.exports, "DropdownItemWithAnalytics", () => $6b540b9522e1fdaf$export$c0117b1abc6c64e3);
$parcel$export(module.exports, "default", () => $6b540b9522e1fdaf$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8dloj = parcelRequire("8dloj");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $iFXD5 = parcelRequire("iFXD5");

var $PdmhA = parcelRequire("PdmhA");

var $ao0hp = parcelRequire("ao0hp");

var $guiFP = parcelRequire("guiFP");

var $jcQrT = parcelRequire("jcQrT");

var $cBaEp = parcelRequire("cBaEp");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $dDDwy = parcelRequire("dDDwy");

var $ihpUY = parcelRequire("ihpUY");

var $k6dT5 = parcelRequire("k6dT5");

var $gGoiH = parcelRequire("gGoiH");
const $6b540b9522e1fdaf$export$34bf1befb2fab61a = ()=>window.connectHost?.dialog?.close();
const $6b540b9522e1fdaf$export$cf40ddca756b7741 = ()=>{
    const topEl = window.AJS?.LayerManager?.global?.getTopLayer();
    if (topEl == null) return null;
    return topEl.find('iframe')?.[0];
};
const $6b540b9522e1fdaf$export$586cda8757903229 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useEffect)(()=>()=>{
            try {
                const dialogBeforeClose = $6b540b9522e1fdaf$export$cf40ddca756b7741();
                $6b540b9522e1fdaf$export$34bf1befb2fab61a();
                const dialogNow = $6b540b9522e1fdaf$export$cf40ddca756b7741();
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), dialogBeforeClose && dialogNow ? 'iframe not closed' : 'iframe closed', 'apps', {
                    // Match the unique key part separated by a final __ delimination
                    uniqueKey: dialogBeforeClose?.id.match(/.*(?=__)/)?.[0] ?? dialogBeforeClose?.id,
                    uniqueOpenKey: dialogNow?.id.match(/.*(?=__)/)?.[0] ?? dialogNow?.id
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'issue-navigator-action-pluggable-items.ui.useModalDialogCleanupEffect',
                        packageName: 'jiraIssueNavigatorActionPluggableItems',
                        teamName: 'empanada'
                    }
                });
            }
        }, [
        createAnalyticsEvent
    ]);
};
const $6b540b9522e1fdaf$export$fc10f874e8bd1adc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const iFrameEstablishedCallback = (0, $eUqFw.useCallback)((payload)=>{
        if (payload.extension.options.moduleType === 'dialogs') (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'iframe established', 'apps', (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(payload.extension.options, [
            'addon_key',
            'isDialog',
            'dialogId',
            'isFullPage',
            'uniqueKey',
            'origin'
        ]));
    }, [
        createAnalyticsEvent
    ]);
    const timeoutIdRef = (0, $eUqFw.useRef)();
    const registerListeners = (0, $eUqFw.useCallback)(()=>{
        // Connect doesn't seem to have a way to notify when it has been registered, so we have to resort to polling
        timeoutIdRef.current = setTimeout(()=>{
            if (!window.connectHost) registerListeners();
            else window.connectHost.onIframeEstablished(iFrameEstablishedCallback);
        }, 1000);
    }, [
        iFrameEstablishedCallback
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>()=>{
            clearTimeout(timeoutIdRef.current);
            // @ts-expect-error - TS2339 - Unsafe use of Connect's internal API
            if (iFrameEstablishedCallback._wrapper != null) window.connectHost?.offIframeEstablished(iFrameEstablishedCallback);
            timeoutIdRef.current = undefined;
        }, [
        iFrameEstablishedCallback,
        registerListeners
    ]);
    return ()=>{
        if (timeoutIdRef.current === undefined) registerListeners();
    };
};
const $6b540b9522e1fdaf$export$84648db9790b0ee = ()=>{
    const { current: styleNode } = (0, $eUqFw.useRef)(document.createElement('style'));
    (0, $eUqFw.useLayoutEffect)(()=>{
        document.head?.appendChild(styleNode);
        styleNode.setAttribute('data-nin-pluggable-items', 'css');
        styleNode.sheet?.insertRule('div.aui-inline-dialog[id^="inline-dialog-webitem-"]{z-index:401}', 0);
        return ()=>{
            document.head?.removeChild(styleNode);
        };
    }, [
        styleNode
    ]);
};
const $6b540b9522e1fdaf$export$c0117b1abc6c64e3 = ({ analyticsAppName: analyticsAppName, analyticsAppCount: analyticsAppCount, analyticsAppType: analyticsAppType, testId: testId, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireDropdownClickUIAnalytics = (0, $eUqFw.useCallback)((event)=>{
        if ('key' in event && event.key != null && event.key !== 'Enter' && event.key !== ' ') return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'apps', {
            uniqueKey: props.id,
            source: 'key' in event ? 'keypress' : 'click',
            appCount: analyticsAppCount,
            appName: analyticsAppName,
            appType: analyticsAppType
        });
    }, [
        analyticsAppCount,
        analyticsAppName,
        analyticsAppType,
        createAnalyticsEvent,
        props.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "menuitem",
        tabIndex: 0,
        onClick: fireDropdownClickUIAnalytics,
        onKeyPress: fireDropdownClickUIAnalytics,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), props));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b540b9522e1fdaf$var$PluggableItems = ()=>{
    const [fetchData, { loading: loading, error: error, data: data }] = (0, $dDDwy.usePluggableItemsQuery)();
    const totalCount = data?.jiraWebSection?.webItems?.totalCount ?? 0;
    const { locale: locale } = (0, $gd0Sp.useTenantContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const allWebItemIds = (0, $eUqFw.useMemo)(()=>data?.jiraWebSection?.webItems?.nodes?.map((item)=>item?.id).filter(Boolean) ?? [], [
        data
    ]);
    const { current: intlCollator } = (0, $eUqFw.useRef)(new Intl.Collator((0, $ao0hp.standardizeLocale)(locale)));
    const registerModalDialogAnalytics = $6b540b9522e1fdaf$export$fc10f874e8bd1adc();
    $6b540b9522e1fdaf$export$586cda8757903229();
    $6b540b9522e1fdaf$export$84648db9790b0ee();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isLoading: loading,
        testId: "issue-navigator-action-pluggable-items.ui.filter-button",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6dT5.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            // Ignore events originating from a matching iframe or an element inside an iframe
            const eventTarget = attrs.event?.target;
            if (eventTarget && eventTarget instanceof HTMLElement && (0, $gGoiH.isInOrIsIFrame)(eventTarget, allWebItemIds)) return;
            if (attrs.isOpen) {
                if (!loading) fetchData(error);
                // Only setup analytics when the dialog is opened
                registerModalDialogAnalytics();
            }
            setIsOpen(attrs.isOpen);
        },
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b540b9522e1fdaf$var$Container, null, !error && totalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, [
        ...data?.jiraWebSection?.webItems?.nodes ?? []
    ].sort((a, b)=>a?.label != null && b?.label != null && intlCollator.compare(a.label, b.label) || 0).map((item)=>item && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b540b9522e1fdaf$export$c0117b1abc6c64e3, {
            testId: "issue-navigator-action-pluggable-items.ui.drop-down-item",
            elemBefore: item.iconUrl != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jcQrT.IconCustom), {
                shouldChangeFillColor: false,
                url: item.iconUrl,
                ariaLabelledBy: item.id ?? undefined
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
                primaryColor: `var(--ds-icon, ${(0, $PdmhA).N500})`,
                label: "",
                testId: "issue-navigator-action-pluggable-items.ui.default-icon"
            }),
            key: item.id,
            title: typeof item.tooltip === 'string' ? item.tooltip : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: item.target ? (0, $gGoiH.buildStyleClass)(item.target) : '',
            id: item.id ?? undefined,
            analyticsAppCount: totalCount,
            analyticsAppName: item.label ?? '',
            analyticsAppType: (0, $gGoiH.translateAppTypeToAnalyticsType)(item.target?.type)
        }, item.label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b540b9522e1fdaf$var$MaxWidthContainer, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        pageAction: "apps",
        onRetry: ()=>fetchData(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "errorDropdown",
        actionSubjectId: "issueNavigatorActionsPluggableItems"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihpUY.Empty), null))));
};
var $6b540b9522e1fdaf$export$2e2bcd8739ae039 = $6b540b9522e1fdaf$var$PluggableItems;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b540b9522e1fdaf$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9p3fh",
            __cmplp.className
        ])
    });
});
const $6b540b9522e1fdaf$var$MaxWidthContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fp3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jcQrT", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $d4e9387190e2bf6e$export$5b6504ec6adf0047);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hhzSj = parcelRequire("hhzSj");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $d4e9387190e2bf6e$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $d4e9387190e2bf6e$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, checkForSvg: checkForSvg = (0, $hhzSj.checkForSvg), ariaLabelledBy: ariaLabelledBy })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d4e9387190e2bf6e$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: $d4e9387190e2bf6e$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && checkForSvg(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
const $d4e9387190e2bf6e$var$styles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)",
    margin: 'space.025'
});

});
parcelRegister("hhzSj", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $7c70caac48e2293d$export$9a369805b0fabb72);
const $7c70caac48e2293d$export$9a369805b0fabb72 = (url)=>{
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const fileType = url// eslint-disable-next-line no-useless-escape
    .split(/\#|\?/)[0].split('.').pop().trim();
    return fileType === 'svg';
};

});


parcelRegister("dDDwy", function(module, exports) {

$parcel$export(module.exports, "usePluggableItemsQuery", () => $2e5812d3180668c4$export$77eee11e2025ce36);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $3mEVr = parcelRequire("3mEVr");

var $5as0a = parcelRequire("5as0a");

var $khyQm = parcelRequire("khyQm");
const $2e5812d3180668c4$export$774a4ee00eaf0f75 = {
    data: undefined,
    loading: false,
    error: false
};
const $2e5812d3180668c4$export$77eee11e2025ce36 = ()=>{
    const [pluggableItems, setPluggableItems] = (0, $eUqFw.useState)({
        ...$2e5812d3180668c4$export$774a4ee00eaf0f75
    });
    const { jql: jql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const key = !jql && (0, $5as0a.isFilterId)(filterId) ? filterId : jql;
    const currentKeyRef = (0, $eUqFw.useRef)(key);
    const lastKeyRef = (0, $eUqFw.useRef)(null);
    const fetchPluggableItems = (0, $eUqFw.useCallback)((forceRefetch = false)=>{
        if (forceRefetch || lastKeyRef.current == null || lastKeyRef.current !== currentKeyRef.current) {
            setPluggableItems({
                data: undefined,
                loading: true,
                error: false
            });
            (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=IssueNavigatorPluggableItemsQuery', {
                body: JSON.stringify({
                    query: (0, $khyQm.ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY),
                    variables: {
                        first: 100
                    }
                })
            }).then((response)=>{
                if (response.errors) setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
                else setPluggableItems({
                    data: response.data,
                    loading: false,
                    error: false
                });
            }).catch(()=>{
                setPluggableItems({
                    data: null,
                    loading: false,
                    error: true
                });
            });
            lastKeyRef.current = currentKeyRef.current;
        }
    }, []);
    // Sync this to avoid recreating the callback and mitigating rerender
    currentKeyRef.current = key;
    return (0, $eUqFw.useMemo)(()=>[
            fetchPluggableItems,
            pluggableItems
        ], [
        pluggableItems,
        fetchPluggableItems
    ]);
};

});
parcelRegister("khyQm", function(module, exports) {

$parcel$export(module.exports, "ISSUE_NAVIGATOR_PLUGGABLE_ITEMS_QUERY", () => $96cb34d89513fb77$export$832447adf89352b6);

var $cEBFL = parcelRequire("cEBFL");
const $96cb34d89513fb77$export$832447adf89352b6 = (0, $cEBFL.gqlTagGira)`
  query IssueNavigatorPluggableItemsQuery($first: Int!) {
    jiraWebSection(input: { location: JIRA_NAVIGATOR }) {
      webItems(first: $first) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          id
          label
          tooltip
          iconUrl
          target {
            type
            addonKey
            moduleKey
            ...on JiraWebItemTargetDialogModule {
              targetKey
            }
          }
        }
      }
    }
  }
`;

});


parcelRegister("ihpUY", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $f37ef6ded7dcd77a$export$1f74963c34e8bfec);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $17zNW = parcelRequire("17zNW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jCtZS = parcelRequire("jCtZS");
const $f37ef6ded7dcd77a$export$1f74963c34e8bfec = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f37ef6ded7dcd77a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f37ef6ded7dcd77a$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $17zNW.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f37ef6ded7dcd77a$var$P, null, formatMessage((0, $jCtZS.default).empty)));
};
const $f37ef6ded7dcd77a$var$ImageWrapperStyles = (0, $1ZAYh.xcss)({
    height: '72px',
    width: '72px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f37ef6ded7dcd77a$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _18s81bs6 _vwz47vkz",
            __cmplp.className
        ])
    });
});
const $f37ef6ded7dcd77a$var$P = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5724jg8 _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("17zNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db74c20798b6f43$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fFQjm")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fFQjm")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $9TZf5 = parcelRequire("9TZf5");

var $fFQjm = parcelRequire("fFQjm");
const $5db74c20798b6f43$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fFQjm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fFQjm))
});
var $5db74c20798b6f43$export$2e2bcd8739ae039 = $5db74c20798b6f43$var$Illustration;
// for advanced use only
const $5db74c20798b6f43$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("fFQjm", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});


parcelRegister("jCtZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $397052eceb7e913a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $397052eceb7e913a$var$messages = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-navigator-action-pluggable-items.empty.empty",
        "defaultMessage": "There are no apps installed for the Issue Navigator"
    }
});
var $397052eceb7e913a$export$2e2bcd8739ae039 = $397052eceb7e913a$var$messages;

});


parcelRegister("gGoiH", function(module, exports) {

$parcel$export(module.exports, "buildStyleClass", () => $deb55f607d998566$export$f8c1d825aaa31bf2);
$parcel$export(module.exports, "isInOrIsIFrame", () => $deb55f607d998566$export$5f8a28ced7cd3069);
$parcel$export(module.exports, "translateAppTypeToAnalyticsType", () => $deb55f607d998566$export$7beec86e5c4555f8);
const $deb55f607d998566$export$f8c1d825aaa31bf2 = (target)=>{
    const classes = [];
    switch(target.type){
        case 'DIALOG':
            classes.push('ap-dialog');
            break;
        case 'DIALOG_MODULE':
            classes.push('ap-dialog');
            if ('targetKey' in target && target.targetKey != null) classes.push(`ap-target-key-${target.targetKey}`);
            break;
        case 'INLINE_DIALOG':
            classes.push('ap-inline-dialog');
            break;
        default:
            break;
    }
    if (target.addonKey != null) classes.push(`ap-plugin-key-${target.addonKey}`);
    if (target.moduleKey != null) classes.push(`ap-module-key-${target.moduleKey}`);
    return classes.join(' ');
};
const $deb55f607d998566$export$5f8a28ced7cd3069 = (element, idLooseMatchList)=>{
    const isIFrameWithMatchingId = element.nodeName === 'IFRAME' && !!idLooseMatchList.find((id)=>element.id.match(id));
    const isDifferentOwnerDocument = element.ownerDocument !== document;
    return isIFrameWithMatchingId || isDifferentOwnerDocument;
};
const $deb55f607d998566$export$7beec86e5c4555f8 = (type)=>{
    switch(type){
        case 'DIALOG':
            return 'dialog';
        case 'DIALOG_MODULE':
            return 'dialog_module';
        case 'INLINE_DIALOG':
            return 'inline_dialog';
        default:
            return 'unknown';
    }
};

});



//# sourceMappingURL=async-pluggable-items.44c5b161.js.map
